/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../../clients/baseClient'
import type { RequestConfig, ResponseErrorConfig } from '../../../../clients/baseClient'
import type {
  MeetingListApiV1CollaborationAppMeetingGetQueryResponse,
  MeetingListApiV1CollaborationAppMeetingGetQueryParams,
  MeetingListApiV1CollaborationAppMeetingGetHeaderParams,
  MeetingListApiV1CollaborationAppMeetingGet422,
} from '../../types/MeetingListApiV1CollaborationAppMeetingGet.ts'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const meetingListApiV1CollaborationAppMeetingGetQueryKey = (params?: MeetingListApiV1CollaborationAppMeetingGetQueryParams) =>
  [{ url: '/api/v1/collaboration_app/meeting' }, ...(params ? [params] : [])] as const

export type MeetingListApiV1CollaborationAppMeetingGetQueryKey = ReturnType<typeof meetingListApiV1CollaborationAppMeetingGetQueryKey>

/**
 * @summary Meeting List
 * {@link /api/v1/collaboration_app/meeting}
 */
export async function meetingListApiV1CollaborationAppMeetingGet(
  params?: MeetingListApiV1CollaborationAppMeetingGetQueryParams,
  headers?: MeetingListApiV1CollaborationAppMeetingGetHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    MeetingListApiV1CollaborationAppMeetingGetQueryResponse,
    ResponseErrorConfig<MeetingListApiV1CollaborationAppMeetingGet422>,
    unknown
  >({ method: 'GET', url: `/api/v1/collaboration_app/meeting`, params, ...requestConfig, headers: { ...headers, ...requestConfig.headers } })
  return res.data
}

export function meetingListApiV1CollaborationAppMeetingGetQueryOptions(
  params?: MeetingListApiV1CollaborationAppMeetingGetQueryParams,
  headers?: MeetingListApiV1CollaborationAppMeetingGetHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = meetingListApiV1CollaborationAppMeetingGetQueryKey(params)
  return queryOptions<
    MeetingListApiV1CollaborationAppMeetingGetQueryResponse,
    ResponseErrorConfig<MeetingListApiV1CollaborationAppMeetingGet422>,
    MeetingListApiV1CollaborationAppMeetingGetQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return meetingListApiV1CollaborationAppMeetingGet(params, headers, config)
    },
  })
}

/**
 * @summary Meeting List
 * {@link /api/v1/collaboration_app/meeting}
 */
export function useMeetingListApiV1CollaborationAppMeetingGet<
  TData = MeetingListApiV1CollaborationAppMeetingGetQueryResponse,
  TQueryData = MeetingListApiV1CollaborationAppMeetingGetQueryResponse,
  TQueryKey extends QueryKey = MeetingListApiV1CollaborationAppMeetingGetQueryKey,
>(
  params?: MeetingListApiV1CollaborationAppMeetingGetQueryParams,
  headers?: MeetingListApiV1CollaborationAppMeetingGetHeaderParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        MeetingListApiV1CollaborationAppMeetingGetQueryResponse,
        ResponseErrorConfig<MeetingListApiV1CollaborationAppMeetingGet422>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {},
) {
  const { query: { client: queryClient, ...queryOptions } = {}, client: config = {} } = options ?? {}
  const queryKey = queryOptions?.queryKey ?? meetingListApiV1CollaborationAppMeetingGetQueryKey(params)

  const query = useQuery(
    {
      ...meetingListApiV1CollaborationAppMeetingGetQueryOptions(params, headers, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<MeetingListApiV1CollaborationAppMeetingGet422>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}